import ICalendarUpdate from "@interfaces/Clients/WhaleShark/calendar/calendarFormatted";

const mapper = (formValues: any): ICalendarUpdate => ({
  title: formValues.title,
  linkImage: formValues.linkImage,
  state: true,
});

export default mapper;
